<template>
  <div class="wg-rating">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="primary white--text wg-bonuses__title">
            Рейтинг текущего этапа
          </v-card-title>
          <v-card-text v-if="loading">
            <p>Список рейтингов загружается...</p>
          </v-card-text>
          <v-card-text v-else class="wg-rating__card-text pt-3">
            <div class="h-table h-table--w12 wg-rating__table">
              <div class="h-table__thead">
                <div class="h-table__tr">
                  <div class="h-table__th wg-rating__table-th wg-rating__table-th--place">Место&nbsp;в<br>рейтинге</div>
                  <div class="h-table__th wg-rating__table-th wg-rating__table-th--office">Филиал</div>
                  <div class="h-table__th wg-rating__table-th wg-rating__table-th--op">ОП</div>
                  <div class="h-table__th wg-rating__table-th wg-rating__table-th--company">
                    {{isManager ? 'Должность' : 'Компания'}}
                  </div>
                  <div class="h-table__th wg-rating__table-th wg-rating__table-th--name">ФИО</div>
                  <div
                    class="h-table__th wg-rating__table-th wg-rating__table-th--bonus"
                    :class="{current: (period === bh.id || (period === null && rating[0].bonuses_extended.length === idx + 1))}"
                    v-for="(bh, idx) in rating[0].bonuses_extended"
                    :key="bh.id"
                    v-html="bh.label ? ChangeLabel(bh.label).headerLabel : 'Итого'"/>
                </div>
              </div>
              <div class="h-table__tbody">
                <div
                  class="h-table__tr wg-rating__table-tr"
                  :class="{current: user.profile_id === r.profile_id}"
                  v-for="(r, idx) in rating"
                  :key="rating.id"
                >
                  <div class="h-table__td wg-rating__table-td wg-rating__table-td--place wg-rating__table-td--first">
                    <div class="wg-rating__table-td-header">Место&nbsp;в&nbsp;рейтинге:</div>
                    <div class="wg-rating__table-td-content">{{idx + 1}}</div>
                  </div>
                  <div class="h-table__td wg-rating__table-td wg-rating__table-td--office">
                    <div class="wg-rating__table-td-header">Филиал:</div>
                    <div class="wg-rating__table-td-content">{{r.office && r.office.affiliate ? r.office.affiliate.name : '---'}}</div>
                  </div>
                  <div class="h-table__td wg-rating__table-td wg-rating__table-td--op">
                    <div class="wg-rating__table-td-header">ОП:</div>
                    <div class="wg-rating__table-td-content">{{r.office ? r.office.name : '---'}}</div>
                  </div>
                  <div class="h-table__td wg-rating__table-td wg-rating__table-td--company">
                    <div class="wg-rating__table-td-header">{{isManager ? 'Должность' : 'Компания'}}:</div>
                    <div class="wg-rating__table-td-content" v-if="isManager">{{r.post ? r.post.name : '---'}}</div>
                    <div class="wg-rating__table-td-content" v-if="isDealer">{{r.dealer ? r.dealer.title : '---'}}</div>
                  </div>
                  <div class="h-table__td wg-rating__table-td wg-rating__table-td--name">
                    <div class="wg-rating__table-td-header">ФИО:</div>
                    <div class="wg-rating__table-td-content">{{r.full_name}}</div>
                  </div>
                  <div
                    class="h-table__td wg-rating__table-td wg-rating__table-td--bonus"
                    v-for="(b, idx) in r.bonuses_for_sales"
                    :class="{current: (period === b.id || (period === null && r.bonuses_for_sales.length === idx + 1))}"
                    :key="b.id"
                  >
                    <div class="wg-rating__table-td-header" v-html="b.label ? ChangeLabel(b.label).tdLabel : 'Итого'"/>
                    <div class="wg-rating__table-td-content">{{b.sum}}</div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['rating', 'loading', 'period'],
  computed: {
    user() { return this.$store.state.user; },
    isManager() { return this.$store.getters.isManager; },
    isDealer() { /* + */ return this.$store.getters.isDealer; },
  },
  methods: {
    /**
     * Изменение заголовка для таблицы
     * @param {string} label - заголовок бонусного этапа
     */
    ChangeLabel(label) {
      const labelArray = label.split(' ');
      const headerLabel = `${labelArray[0]}<br>${labelArray[1]}&nbsp;${labelArray[2]}`;
      const tdLabel = `${labelArray[0]}&nbsp;${labelArray[1]}&nbsp;${labelArray[2]}`;
      return { headerLabel, tdLabel };
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/scss/variables";

.wg-rating {
  &__card-text {
    @media (min-width: 1200px) {
      overflow-x: auto;
    }
  }

  &__table-tr {
    @media (max-width: 1200px) {
      border: 1px solid variables.$wg-rating-table-border-color;
      padding: 6px;
      margin-bottom: 30px;
    }

    &.current {
      .wg-rating__table-td {
        &--name {
          background-color: variables.$wg-rating-table-current-accent-td-bg-color;
        }
        &.current {
          background-color: variables.$wg-rating-table-current-accent-td-bg-color;
        }
      }
      @media (max-width: 1200px) {
        background-color: variables.$wg-rating-table-current-td-bg-color;
      }
      @media (min-width: 1200px) {
        .wg-rating__table-td {
          background-color: variables.$wg-rating-table-current-td-bg-color;

          &--name {
            background-color: variables.$wg-rating-table-current-accent-td-bg-color;
          }
        }
      }
    }
  }
  &__table-th {
    display: none;
    border-right: 1px solid variables.$wg-rating-table-border-color;
    color: variables.$wg-rating-table-header-color;
    font-size: 14px;

    @media (min-width: 1200px) {
      display: table-cell;
      padding: 4px;
    }

    &:last-child {
      border-right: none;
    }

    &.current {
      background-color: variables.$wg-rating-table-current-td-bg-color;
    }
  }
  &__table-td {
    border-top: 1px solid variables.$wg-rating-table-border-color;
    border-right: 1px solid variables.$wg-rating-table-border-color;
    padding: 4px;
    font-size: 12px;

    @media (max-width: 1200px) {
      display: flex;
      justify-content: space-between;
      border-right: none;
      border-top: 1px dotted variables.$wg-rating-table-border-color;
    }

    &:last-child {
      border-right: none;
    }

    &--first {
      @media (max-width: 1200px) {
        border-top: none;
      }
    }

    &--place,
    &--bonus,
    &--sum {
      text-align: center;
    }

    &.current {
      background-color: variables.$wg-rating-table-current-td-bg-color;
    }
  }
  &__table-td-header {
    padding-right: 4px;
    color: variables.$wg-rating-table-header-color;

    @media (min-width: 1200px) {
      display: none;
    }
  }
  &__table-td-content {
    font-weight: bold;
  }
}
</style>
